import { h } from 'preact';

const CustomButton = props => {
  const children = props.children;
  const isLoading = props.isLoading;
  delete props.children;
  delete props.isLoading;
  if (isLoading) {
    return (
      <button class="btn btn-primary" type="button" disabled>
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
        <span class="visually-hidden">Loading...</span>
        <span>&nbsp; {children}</span>
      </button>
    );
  }
  return <button {...props}>{children}</button>;
};

export default CustomButton;
